import { render, staticRenderFns } from "./FirstSaleAchievementModal.vue?vue&type=template&id=5b7d4e23&scoped=true"
import script from "./FirstSaleAchievementModal.vue?vue&type=script&lang=js"
export * from "./FirstSaleAchievementModal.vue?vue&type=script&lang=js"
import style0 from "./FirstSaleAchievementModal.vue?vue&type=style&index=0&id=5b7d4e23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7d4e23",
  null
  
)

export default component.exports